import { brand } from './brand';
import { defaultFocusStyles } from './defaultFocusStyles';
export const linkStyles = {
    cursor: 'pointer',
    color: brand.link.color.default.content,
    textDecoration: 'underline',
    '&:visited': {
        color: brand.link.color.visited.content,
    },
    '&:visited:hover, &:visited:active': {
        color: brand.link.color.hover.content,
    },
    '&:hover, &:active': {
        color: brand.link.color.visited.content,
    },
    ...defaultFocusStyles,
};
